var _g, _ellipse, _ellipse2, _ellipse3, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _g2, _ellipse4, _ellipse5, _ellipse6, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRealEstate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 355,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#real-estate_svg__filter0_di)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 440,
    height: 280,
    rx: 12.279,
    fill: "url(#real-estate_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 440,
    height: 280,
    rx: 12.279,
    stroke: "#EEE",
    strokeWidth: 0.767
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.862,
    cy: 25.334,
    rx: 2.745,
    ry: 2.964,
    fill: "#ED6A5D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.011,
    cy: 25.334,
    rx: 2.745,
    ry: 2.964,
    fill: "#F4BF4F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.163,
    cy: 25.334,
    rx: 2.745,
    ry: 2.964,
    fill: "#62C755"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M274 77.535c0-.848.687-1.535 1.535-1.535h144.93c.848 0 1.535.687 1.535 1.535v21.93c0 .848-.687 1.535-1.535 1.535h-144.93A1.535 1.535 0 01274 99.465v-21.93z",
    fill: "#C4C4C4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 114,
    y: 76,
    width: 146,
    height: 138,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 68.254,
    y: 223.757,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 107.395,
    y: 223.757,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 146.535,
    y: 223.757,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 185.676,
    y: 223.757,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 116.848,
    width: 46.814,
    height: 24.863,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 154.142,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 113.535,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 167.254,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 220.977,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 274.699,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 328.418,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 382.141,
    y: 49.718,
    width: 39.139,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 170.717,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 187.292,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 250.906,
    y: 203.867,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#real-estate_svg__filter1_di)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 88,
    width: 440,
    height: 252,
    rx: 12.279,
    fill: "url(#real-estate_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 88,
    width: 440,
    height: 252,
    rx: 12.279,
    stroke: "#EEE",
    strokeWidth: 0.767
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.745,
    cy: 105.964,
    rx: 2.745,
    ry: 2.964,
    fill: "#ED6A5D"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.894,
    cy: 105.964,
    rx: 2.745,
    ry: 2.964,
    fill: "#F4BF4F"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.046,
    cy: 105.964,
    rx: 2.745,
    ry: 2.964,
    fill: "#62C755"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 298.789,
    y: 148.869,
    width: 155.023,
    height: 24.863,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 116.137,
    y: 148.869,
    width: 151.953,
    height: 137.574,
    rx: 6.14,
    fill: "#C4C4C4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 116.137,
    y: 296.388,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 155.277,
    y: 296.388,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 194.418,
    y: 296.388,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 233.559,
    y: 296.388,
    width: 33.767,
    height: 33.15,
    rx: 3.07,
    fill: "#C4C4C4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 298.789,
    y: 189.478,
    width: 46.814,
    height: 24.863,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 298.789,
    y: 226.772,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 116.137,
    y: 130.637,
    width: 64.465,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 298.789,
    y: 243.348,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 298.789,
    y: 259.923,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 298.789,
    y: 276.498,
    width: 155.023,
    height: 9.945,
    rx: 1.535,
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "real-estate_svg__paint0_linear",
    x1: 233,
    y1: 12,
    x2: 233,
    y2: 292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "real-estate_svg__paint1_linear",
    x1: 278,
    y1: 88,
    x2: 278,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "real-estate_svg__filter0_di",
    x: 0.337,
    y: 0.872,
    width: 465.326,
    height: 305.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.535
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.592157 0 0 0 0 0.596078 0 0 0 0 0.678431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.535,
    dy: 2.302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "real-estate_svg__filter1_di",
    x: 45.337,
    y: 76.872,
    width: 465.326,
    height: 277.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.535
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.592157 0 0 0 0 0.596078 0 0 0 0 0.678431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.535,
    dy: 2.302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow"
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgRealEstate as ReactComponent };